import { render, staticRenderFns } from "./LangDropdown.vue?vue&type=template&id=20335006&"
import script from "./LangDropdown.vue?vue&type=script&lang=js&"
export * from "./LangDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports